class CookieConsent extends HTMLElement {
	constructor() {
		super();

        this.cookie = this;

		if (this.getCookie('cookie-consent') === ''){
            this.cookie.style.display = "flex";
            document.body.style.overflow = "hidden";
		} else {
			this.remove();
			return;
		}

		this.querySelector('[data-accept-cookie]').addEventListener(
            'click',
            this.setClosePopup.bind(this, 'accepted')
        );

		this.querySelector('[data-deny-cookie]').addEventListener(
            'click',
            this.setClosePopup.bind(this, 'denied')
        );

		this.querySelectorAll('[data-cookie-dismiss]').forEach((el) => {
			el.addEventListener('click', this.setClosePopup.bind(this, 'denied'));
		});
	}

	setCookie(cname, cvalue) {
        document.cookie = cname + '=' + cvalue + ';path=/';
    }

	getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }

        return '';
    }

    deleteCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    setClosePopup(value, event) {
        event.preventDefault();

        this.setCookie('cookie-consent', value);
        document.body.style.overflow = "";
        this.cookie.remove();
    }
}

customElements.define('cookie-consent', CookieConsent);
